import {
  Background,
  DivSave,
  Cardo,
  FormDiv,
  Infos,
  CursoTurmaDiscInfo,
  DivTitle,
  DragAndDropArea2,
  FileInfo,
  FileDetails,
  HiddenFileInput,
  ContainerTable,
  DivideTable,
  NoSelected,
  ResumoInfo,
} from "./style.js";
import Button from "../../Button/index.jsx";
import InputSelect from "../../Select/index.jsx";
import useProgressaoForm from "../../../hooks/useProgressaoForm.js";
import AlunosSecao from "./AlunoSecao/index.jsx";
import FormSection1 from "./FormSecao1/index.jsx";
import FormSection2 from "./FormSecao2/index.jsx";
import { Alert } from "../../../utils/Alert.js";
import Loading from "../../../utils/Loading/index.jsx";
import { formatFileSize } from "../../../utils/fileUtils.js";
import Input from "../../Input/index.jsx";
import { formatDatePtBr } from "../../../utils/dateUtils.js";

const CardProgressao = ({ show, setShow, mode = "add", progressaoEdit }) => {
  if (!show) return null;

  const {
    // States
    alunos,
    cursos,
    selectedCursoNome,
    setSelectedCursoNome,
    selectedCursoId,
    setSelectedCursoId,
    turmas,
    selectedSemestreAno,
    setSelectedSemestreAno,
    selectedTurmaId,
    setSelectedTurmaId,
    selectedTurmaNome,
    setSelectedTurmaNome,
    disciplinas,
    selectedDisciplinaNome,
    setSelectedDisciplinaNome,
    selectedDisciplinaId,
    setSelectedDisciplinaId,
    mostrarAlunosSelecionados,
    setMostrarAlunosSelecionados,
    mostrarAlunos,
    setAlunos,
    setAlunosBk,
    setMostrarAlunos,
    selecionarAluno,
    setSelecionarAluno,
    steps,
    setSteps,
    file,
    setFile,
    fileUrl,
    setFileUrl,
    fileUrlEdit,
    setFileUrlEdit,
    uploading,
    loading,
    loading2,
    loading3,
    dragActive,
    setSearchRm,
    setSearchNome,
    errorText,
    fileSize,
    alunoLoading,
    complementosProg,
    setComplementosProg,
    setDataInicio,
    setDataFim,
    isEditMode,
    filteredAlunos,
    valueInputDateInicio,
    valueInputDateFim,
    minimoDateFim,
    semAlunos,
    naoComecou,
    mostrarPdf,
    setMostrarPdf,
    setRemoveuFile,

    // Functions
    handleFileChange,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleDataInicioChange,
    handleDataFimChange,
    handleUploadClick,
    handleEditSave,
    handleFechar,
    handleSelecionarAluno,
    handleContinuar,
    handleListarTurmas,
    handleGetDisciplina,
    handleListarAlunos,
    fetchProgressaoTemporaria,
    saveProgressaoTemporaria,
  } = useProgressaoForm(show, setShow, mode, progressaoEdit);

  const CursoInfo = (resumo = false) => {
    if (isEditMode && !resumo) {
      const turma = progressaoEdit?.turma_rh?.split(",")[1].split("-").slice(1).join(" - ");
      const curso = progressaoEdit?.curso_rh
        ?.split(",")[1]
        .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
        .trim();

      return (
        <Infos>
          <CursoTurmaDiscInfo>
            Curso <p>{curso}</p>
          </CursoTurmaDiscInfo>
          <CursoTurmaDiscInfo>
            Turma <p>{turma}</p>
          </CursoTurmaDiscInfo>
          <CursoTurmaDiscInfo>
            Disciplina <p>{progressaoEdit.disciplina_rh.split(", ")[1]}</p>
          </CursoTurmaDiscInfo>
        </Infos>
      );
    }

    if (resumo) {
      const curso =
        progressaoEdit?.curso_rh
          ?.split(",")[1]
          .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
          .trim() ?? selectedCursoNome?.replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")?.trim();

      const turma =
        progressaoEdit?.turma_rh?.split(",")[1].split("-").slice(1).join(" - ")?.trim() ??
        selectedTurmaNome?.split("-")?.slice(1)?.join(" - ")?.trim();

      const disciplina = progressaoEdit?.disciplina_rh?.split(", ")[1]?.trim() ?? selectedDisciplinaNome?.trim();

      return (
        <>
          <Infos>
            <CursoTurmaDiscInfo>
              Curso <p>{curso}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Turma <p>{turma}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Disciplina <p>{disciplina}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Início da Progressão <p>{formatDatePtBr(valueInputDateInicio)}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Limite de Entrega <p>{formatDatePtBr(valueInputDateFim)}</p>
            </CursoTurmaDiscInfo>
          </Infos>
          <Infos $resumo={resumo}>
            <ResumoInfo>
              I. Competências/Habilidades esperadas: <p>{complementosProg.competencias}</p>
            </ResumoInfo>
            <ResumoInfo>
              II. Conhecimentos conteúdos: <p>{complementosProg.conhecimento}</p>
            </ResumoInfo>
            <ResumoInfo>
              III. Metodologia e procedimentos didáticos: <p>{complementosProg.metodologia}</p>
            </ResumoInfo>
            <ResumoInfo>
              IV. Critérios de avaliação: <p>{complementosProg.criterios}</p>
            </ResumoInfo>
            <ResumoInfo>
              V. Cronograma das etapas (períodos - atividades): <p>{complementosProg.cronogramas}</p>
            </ResumoInfo>
            <ResumoInfo>
              VI. Material de apoio didático para os alunos: <p>{complementosProg.material_apoio}</p>
            </ResumoInfo>
            <ResumoInfo>
              VII. Observações para o aluno: <p>{complementosProg.orientacoes ?? "Sem Informações"}</p>
            </ResumoInfo>
          </Infos>
        </>
      );
    }

    const style1 = { color: "#1a2e35" };
    const style2 = {
      width: "15vw",
      color: "#fff",
      background: "linear-gradient(135deg, #1a2e35 0%, #263654 100%)",
      border: "2px solid #1a2e35",
      paddingLeft: "10px",
      paddingRight: "25px",
    };
    const style3 = { color: "#fff", backgroundColor: "#1a2e35" };

    const semestreAno =
      turmas.length > 0
        ? [
            ...new Set(
              turmas
                .map((turma) => {
                  const match = turma.label.match(/(\d{2}\/\d{4})/i); // Captura o padrão "MM/AAAA"
                  return match ? match[1] : turma.label; // Retorna "01/2023" ou null ou curso sem turma associada
                })
                .filter((s) => s) // Remove valores null/undefined
            ),
          ].sort((a, b) => {
            // Ordenação: ano decrescente, depois mês decrescente
            const [mesA, anoA] = a.split("/");
            const [mesB, anoB] = b.split("/");

            if (anoA !== anoB) {
              return parseInt(anoB) - parseInt(anoA); // 2025 → 2024 → 2023
            }
            return parseInt(mesB) - parseInt(mesA); // 12 → 01
          })
        : [];

    return (
      <>
        <InputSelect
          Style1={style1}
          Style2={style2}
          Style3={style3}
          Label={"Cursos"}
          Options={cursos}
          Default={selectedCursoId && selectedCursoNome ? selectedCursoId + "," + selectedCursoNome : "-"}
          OnChange={(e) => {
            const [id, nome] = e.target.value.split(",");
            setSearchNome("");
            setSearchRm("");
            setSelectedSemestreAno("");
            setSelectedTurmaId("");
            setSelectedTurmaNome("");
            setSelecionarAluno([]);
            setSelectedCursoId(id);
            setSelectedCursoNome(nome);
            handleListarTurmas(id);
          }}
        />
        <InputSelect
          Style1={style1}
          Style2={style2}
          Style3={style3}
          Label={"Semestre/Ano"}
          Options={
            semestreAno.length > 0 ? [...semestreAno.map((semestAno) => ({ label: semestAno, value: semestAno }))] : []
          }
          Default={selectedSemestreAno}
          OnChange={(e) => {
            setSearchNome("");
            setSearchRm("");
            setSelectedTurmaId("");
            setSelectedTurmaNome("");
            setSelecionarAluno([]);
            handleGetDisciplina(0);
            const value = e.target.value.split(",");
            setSelectedSemestreAno(value);
          }}
        />
        <InputSelect
          Style1={style1}
          Style2={style2}
          Style3={style3}
          Label={"Turmas"}
          Options={
            selectedSemestreAno
              ? [{ label: "-", value: 0 }, ...turmas.filter((t) => t.label.includes(selectedSemestreAno))]
              : []
          }
          Default={selectedTurmaId && selectedTurmaNome ? selectedTurmaId + "," + selectedTurmaNome : "-"}
          OnChange={(e) => {
            const [id, nome] = e.target.value.split(",");
            setSearchNome("");
            setSearchRm("");
            setSelecionarAluno([]);
            setSelectedTurmaId(id);
            setSelectedTurmaNome(nome);
            handleGetDisciplina(id);
          }}
        />
        <InputSelect
          Style1={style1}
          Style2={style2}
          Style3={style3}
          Label={"Disciplinas"}
          Options={disciplinas}
          Default={
            selectedDisciplinaId && selectedDisciplinaNome ? selectedDisciplinaId + "," + selectedDisciplinaNome : "-"
          }
          OnChange={(e) => {
            setSearchNome("");
            setSearchRm("");
            setAlunosBk([]);
            setAlunos([]);
            if (e.target.value === "0") {
              setSelectedDisciplinaId("0");
              setSelectedDisciplinaNome("");
              setSelecionarAluno([]);
              return;
            }
            const [id, nome] = e.target.value.split(",");
            setSelecionarAluno([]);
            setSelectedDisciplinaId(id);
            setSelectedDisciplinaNome(nome);
            handleListarAlunos(selectedCursoId);
          }}
        />
      </>
    );
  };

  return (
    <Background>
      <Cardo $steps={steps}>
        <DivTitle>
          <h1>{isEditMode ? "Editar" : "Adicionar"} Progressão Parcial</h1>
          <div className="status">
            {/* <h2 style={styleHeader}>Etapas</h2> */}
            <h2 className={`s1 ${steps == 1 ? "selecionado" : ""}`}>1 - Formulário</h2>
            <h2 className={`s2 ${steps == 2 ? "selecionado" : ""}`}>2 - Prazo e Anexos</h2>
            <h2 className={`s3 ${steps == 3 ? "selecionado" : ""}`}>3 - Seleção de Alunos</h2>
            <h2 className={`s4 ${steps == 4 ? "selecionado" : ""}`}>4 - Revisão</h2>
            {/* <h2 style={styleHeader}>{steps}/4</h2> */}
          </div>
        </DivTitle>

        {steps === 1 && (
          <>
            <FormSection1
              isEditMode={isEditMode}
              complementosProg={complementosProg}
              setComplementosProg={setComplementosProg}
              fetchProgressaoTemporaria={fetchProgressaoTemporaria}
            />
            <DivSave>
              <Button
                event={(e) => handleFechar(e, false)}
                width="7rem"
                placeholder={"Fechar"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
              <Button
                event={() => {
                  handleContinuar();
                  saveProgressaoTemporaria();
                }}
                tabIndex={8}
                width={isEditMode ? "9rem" : "8rem"}
                placeholder={"Próximo"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
            </DivSave>
          </>
        )}

        {steps === 2 && (
          <>
            <FormSection2
              isEditMode={isEditMode}
              valueInputDateInicio={valueInputDateInicio}
              naoComecou={naoComecou}
              handleDataInicioChange={handleDataInicioChange}
              progressaoEdit={progressaoEdit}
              setDataInicio={setDataInicio}
              setDataFim={setDataFim}
              valueInputDateFim={valueInputDateFim}
              minimoDateFim={minimoDateFim}
              handleDataFimChange={handleDataFimChange}
              dragActive={dragActive}
              fileUrlEdit={fileUrlEdit}
              fileUrl={fileUrl}
              loading3={loading3}
              handleDragOver={handleDragOver}
              handleDragLeave={handleDragLeave}
              handleDrop={handleDrop}
              handleFileChange={handleFileChange}
            />
            <DivSave>
              <Button
                event={() => setSteps(1)}
                width="8rem"
                placeholder={"Voltar"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
              {loading3 ? (
                <Loading />
              ) : fileUrlEdit ? (
                <DragAndDropArea2>
                  <FileInfo>
                    <span>
                      NOME:{" "}
                      {isEditMode && file?.name /*&& progressaoEdit.pdf
                        ? `${progressaoEdit.pdf.split("_")[0]}_${file.name}`
                        : isEditMode && file?.name*/
                        ? `${file.name}`
                        : progressaoEdit.pdf && progressaoEdit.pdf.toLowerCase().includes(".pdf")
                        ? progressaoEdit.pdf?.split("_")[1]
                        : `${progressaoEdit.pdf?.split("_")[1]}.PDF`}
                    </span>
                    <FileDetails>Tamanho: {file ? formatFileSize(file.size) : "N/A"}</FileDetails>
                  </FileInfo>
                  <Button
                    event={() => {
                      setFileUrl(null);
                      setFile(null);
                      setFileUrlEdit(null);
                      setRemoveuFile(true);
                    }}
                    placeholder={`Remover PDF`}
                    background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                    borderRadius="10px"
                    width="12rem"
                    padding="10px"
                    margin={0}
                    fontsize="15px"
                  />
                </DragAndDropArea2>
              ) : fileUrl ? (
                <DragAndDropArea2>
                  <FileInfo>
                    <span>
                      NOME:{" "}
                      {isEditMode
                        ? progressaoEdit.pdf && progressaoEdit.pdf.toLowerCase().includes(".pdf")
                          ? progressaoEdit.pdf?.split("_")[1]
                          : `${progressaoEdit.pdf?.split("_")[1]}.PDF`
                        : file?.name}
                    </span>
                    {fileSize.kb && (
                      <FileDetails>
                        Tamanho do arquivo: ({fileSize.kb} KB, {fileSize.mb} MB
                        {fileSize.gb > 0.01 ? `, ${fileSize.gb} GB` : ""})
                      </FileDetails>
                    )}
                  </FileInfo>
                  <Button
                    event={() => {
                      // if (!isEditMode) {
                      setFileUrl(null);
                      setFile(null);
                      setFileUrlEdit(null);
                      setRemoveuFile(true);
                      // }
                    }}
                    placeholder={
                      // isEditMode ? (
                      //   <div>
                      //     Trocar PDF
                      //     <HiddenFileInput type="file" accept=".pdf" onChange={handleFileChange} />
                      //   </div>
                      // ) : (
                      `Remover PDF`
                      // )
                    }
                    background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                    borderRadius="10px"
                    width="12rem"
                    padding="10px"
                    margin={0}
                    fontsize="15px"
                  />
                </DragAndDropArea2>
              ) : null}
              <Button
                event={() => {
                  handleContinuar();
                  saveProgressaoTemporaria();
                }}
                width="12rem"
                placeholder={"Próximo"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
            </DivSave>
          </>
        )}

        {steps === 3 && (
          <>
            <FormDiv $border={true} $padding={true}>
              {CursoInfo()}
            </FormDiv>
            <AlunosSecao
              loading={loading}
              loading2={loading2}
              semAlunos={semAlunos}
              errorText={errorText}
              mostrarAlunosSelecionados={mostrarAlunosSelecionados}
              setMostrarAlunosSelecionados={setMostrarAlunosSelecionados}
              selecionarAluno={selecionarAluno}
              handleSelecionarAluno={handleSelecionarAluno}
              alunoLoading={alunoLoading}
              setSearchRm={setSearchRm}
              setSearchNome={setSearchNome}
              mostrarAlunos={mostrarAlunos}
              setMostrarAlunos={setMostrarAlunos}
              alunos={alunos}
              filteredAlunos={filteredAlunos}
              isEditMode={isEditMode}
            />
            <DivSave>
              <Button
                event={() => setSteps(2)}
                width="8rem"
                placeholder={"Voltar"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
              <Button
                event={handleContinuar}
                width={"8rem"}
                placeholder={"Próximo"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
                disabled={
                  uploading ||
                  loading ||
                  loading2 ||
                  loading3 ||
                  (isEditMode && Object.values(alunoLoading).some(Boolean))
                }
              />
            </DivSave>
          </>
        )}

        {steps === 4 && (
          <>
            <ContainerTable style={{ display: "block", overflowY: "auto" }}>
              {CursoInfo(true)}
              {/* <FormSection1
                isRevisaoMode={true}
                isEditMode={isEditMode}
                complementosProg={complementosProg}
                setComplementosProg={setComplementosProg}
              />*/}
              <AlunosSecao
                isRevisaoMode={true}
                semAlunos={semAlunos}
                mostrarAlunosSelecionados={mostrarAlunosSelecionados}
                setMostrarAlunosSelecionados={setMostrarAlunosSelecionados}
                setSearchRm={setSearchRm}
                setSearchNome={setSearchNome}
                mostrarAlunos={mostrarAlunos}
                setMostrarAlunos={setMostrarAlunos}
                selecionarAluno={selecionarAluno}
                isEditMode={isEditMode}
              />

              {(fileUrlEdit || fileUrl) && (
                <DivideTable onClick={() => setMostrarPdf(!mostrarPdf)} style={{ padding: 0 }}>
                  {!mostrarPdf ? (
                    <NoSelected style={{ display: "flex", gap: 10 }}>
                      {/* <IoIosArrowDropupCircle /> */}
                      Clique para exibir o PDF
                      {/* <IoIosArrowDropupCircle /> */}
                    </NoSelected>
                  ) : (
                    <NoSelected style={{ display: "flex", gap: 10 }}>
                      {/* <IoIosArrowDropdownCircle />  */}
                      Clique para ocultar o PDF
                      {/* <IoIosArrowDropdownCircle /> */}
                    </NoSelected>
                  )}
                </DivideTable>
              )}
              {(fileUrlEdit || fileUrl) && mostrarPdf && (
                <FormSection2
                  isRevisaoMode={true}
                  progressaoEdit={progressaoEdit}
                  dragActive={dragActive}
                  fileUrlEdit={fileUrlEdit}
                  fileUrl={fileUrl}
                  loading3={loading3}
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleDrop={handleDrop}
                  handleFileChange={handleFileChange}
                />
              )}
            </ContainerTable>
            <DivSave>
              <Button
                event={() => setSteps(3)}
                width="8rem"
                placeholder={"Voltar"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
              />
              <Button
                event={() => {
                  isEditMode ? handleEditSave() : handleUploadClick();
                }}
                width={"8rem"}
                placeholder={"Salvar"}
                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                borderRadius="10px"
                disabled={
                  uploading ||
                  loading ||
                  loading2 ||
                  loading3 ||
                  (isEditMode && Object.values(alunoLoading).some(Boolean))
                }
              />
            </DivSave>
          </>
        )}
      </Cardo>
    </Background>
  );
};

export default CardProgressao;
